// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-87359d22] .plugin-icon{height:20px!important;width:20px!important}[data-v-87359d22] .scroller__item{border-radius:5px;padding-left:10px}[data-v-87359d22] .scroller__item--selected,[data-v-87359d22] .scroller__item:hover{background-color:var(--background-color-accent)}[data-v-87359d22] .scroller__item:before{content:none!important}", ""]);
// Exports
module.exports = exports;
